
import { computed, defineComponent, PropType } from "vue";
import UserListTableHeader from "@/components/table/list/UserListTableHeader/UserListTableHeader.vue";
import GuardianListTableRow from "@/views/guardian/_components/GuardianListTable/GuardianListTableRow/GuardianListTableRow.vue";
import { Guardian } from "@/ts/objects/entity/guardian";
import { getGuardianColumnDefs } from "@/ts/app/columns/def/guardian/guardian-column";
import { GuardianColumnVisibilityAll } from "@/ts/app/columns/visibility/guardian-column-visibility";

export default defineComponent({
  name: "GuardianListTable",
  components: {
    GuardianListTableRow,
    UserListTableHeader,
  },
  props: {
    horizontalMargin: { type: Number, default: 24 },

    guardians: { type: Array as PropType<Guardian[]>, required: true },
    columnVisibility: {
      type: Object as PropType<GuardianColumnVisibilityAll>,
      required: true,
    },

    /**
     * ユーザーIDから、編集画面のパスを取得する。
     * 未指定の場合、編集画面へのリンクが現れない。
     */
    userIdToEditPath: {
      type: Function as PropType<(userId: string) => string>,
      required: false,
    },

    /**
     * trueなら、ユーザー項目などをリンク化する。
     */
    linkEnabled: { type: Boolean, required: true },
  },
  setup(props) {
    const allColumns = getGuardianColumnDefs();

    return {
      allColumns,
      flattenedColumnVisibility: computed(() => ({
        ...props.columnVisibility.profileColumnVisibility.state,
        ...props.columnVisibility.notesColumnVisibility.state,
      })),

      iconCellWidth: 28,
      nameCellWidth: 120,
      styles: { "--horizontal-margin": `${props.horizontalMargin}px` },
    };
  },
});
